import { Alert } from "@schaeffler-commerce/design-system";
import ConfirmationModal from "~/common/components/ConfirmationModal";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useTranslation } from "react-i18next";

interface UndoPartnerPopupConfirmationProps {
  onOk: () => void;
  onCancel: () => void;
}

export const useUndoPartnerPopupConfirmation = ({ onOk, onCancel }: UndoPartnerPopupConfirmationProps) => {
  const { setTrue: openPopup, setFalse: closePopup, val: isModalOpen } = useBooleanState(false);

  const open = () => {
    openPopup();
  };

  const close = () => {
    closePopup();
  };

  const { t } = useTranslation();

  const ok = t("common.yes");
  const cancel = t("contactUsPage.form.cancel");

  const modal = isModalOpen && (
    <ConfirmationModal okLabel={ok} cancelLabel={cancel} onOk={onOk} onCancel={onCancel}>
      <Alert severity={"info"} className={"mb-30"}>
        {t("affiliateSalesPartner.banner.undo.popup.message")}
      </Alert>
    </ConfirmationModal>
  );

  return { modal, open, close, visible: isModalOpen } as const;
};
